<template>
  <div class="picnic-content-editor">
    <div class="picnic-fieldset-wrap picnic-fieldset-wrap--dark">
      <!-- <button v-on:click="addImage()">Add Image</button> -->
      <div
        ref="wrapper"
        class="ps-editor picnic-content-editor__wrapper picnic-markdown"
      ></div>
    </div>
  </div>
</template>

<script>
import { EditorState, Plugin, PluginKey } from 'prosemirror-state'
import { EditorView, Decoration, DecorationSet } from 'prosemirror-view'
import { keymap } from 'prosemirror-keymap'
import { history, undo, redo } from 'prosemirror-history'
import { baseKeymap } from 'prosemirror-commands'
import {
  schema,
  defaultMarkdownParser,
  defaultMarkdownSerializer
} from 'prosemirror-markdown'

const placeholderPlugin = new Plugin({
  key: new PluginKey('placeholder'),
  state: {
    init: () => DecorationSet.empty,
    apply(tr, set) {
      // Adjust decoration positions to changes made by the transaction
      set = set.map(tr.mapping, tr.doc)
      // See if the transaction adds or removes any placeholders
      let action = tr.getMeta(this)
      if (action && action.add) {
        let image = document.createElement('img')
        image.src = action.add.src
        image.className = 'placeholder-image'
        let deco = Decoration.widget(action.add.pos, image, {
          id: action.add.id
        })
        set = set.add(tr.doc, [deco])
      } else if (action && action.remove) {
        set = set.remove(
          set.find(null, null, spec => spec.id == action.remove.id)
        )
      }
      return set
    }
  },
  props: {
    decorations(state) {
      return this.getState(state)
    }
  }
})

function createState(doc) {
  return EditorState.create({
    doc: doc,
    plugins: [
      placeholderPlugin,
      history(),
      keymap(baseKeymap),
      keymap({
        'Mod-z': undo,
        'Mod-y': redo
      })
    ]
  })
}

let pasteEvent
let view = {}

export default {
  name: 'markdown-editor',
  props: ['value', 'ticketIntegrationId', 'createMode'],
  data() {
    return {
      content: this.value
    }
  },
  methods: {
    placeholderFocused: function placeholderFocused() {
      this.initializeProsemirror()
    },
    initializeProsemirror: function initializeProsemirror() {
      this.showPlaceholder = false
      this.$nextTick(() => {
        const wrapper = this.$refs.wrapper
        const doc = defaultMarkdownParser.parse(this.content)
        view = new EditorView(wrapper, {
          state: createState(doc),
          dispatchTransaction: tr => {
            console.log('dispatch transaction', tr)
            view.updateState(view.state.apply(tr))
            this.content = defaultMarkdownSerializer.serialize(view.state.doc)
            console.log(this.content)
            this.$emit('input', this.content)
          }
          // handleDrop: (view, event, slice) => {
          //   console.log('drop')
          // },
          // handleClick: (view, event, slice) => {
          //   console.log('click')
          //   setTimeout(function() {
          //     console.log('manual focus')
          //     wrapper.children[0].focus();
          //   }, 0);
          // },
          // handleTextInput: (view, event, slice) => {
          //   console.log('text pinput')
          // },
          // handleKeyDown: (view, event, slice) => {
          //   console.log('keydown')
          // },
          // handleKeyPress: (view, event, slice) => {
          //   console.log('keyPress')
          // },
          // handlePaste: (view, event, slice) => {
          //   console.log('handle paste is being called')
          // },
          // handlePaste: (view, event, slice) => {
          //   console.log('paste!!!')
          //     if (
          //       event.clipboardData &&
          //       event.clipboardData.items &&
          //       event.clipboardData.items.length > 0
          //     ) {
          //       [...event.clipboardData.items].forEach(item => {
          //         if (item.type.indexOf("image") !== -1) {
          //           const id = Math.floor(Math.random() * 1000000);
          //           const file = item.getAsFile();
          //           this.uploadImage(file).then(url => {
          //             let pos = this.findPlaceholder(id);
          //             if (pos == null) return;
          //             const image = schema.node("image", { src: url });
          //             const addImageTransaction = this.view.state.tr
          //               .replaceWith(pos, pos, image)
          //               .setMeta(placeholderPlugin, { remove: { id } });
          //             this.view.dispatch(addImageTransaction);
          //           });
          //           this.convertFileToDataUrl(file).then(url => {
          //             const tr = this.view.state.tr;
          //             if (!tr.selection.empty) {
          //               tr.deleteSelection();
          //             }
          //             tr.setMeta(placeholderPlugin, {
          //               add: { id, pos: tr.selection.from, src: url }
          //             });
          //             this.view.dispatch(tr);
          //           });
          //         }
          //       });
          //     }
          //   }
        })
        // if (!this.$store.getters.isTouchDevice) {
        //   wrapper.children[0].focus();
        // }
      })
    },
    addImage: function() {
      const image = schema.node('image', {
        src: 'https://vuejs.org/images/logo.png'
      })
      const addImageTransaction = view.state.tr.insert(0, image)
      view.dispatch(addImageTransaction)
    },
    convertFileToDataUrl: function(file) {
      return new Promise(resolve => {
        const reader = new FileReader()
        reader.addEventListener('loadend', () => {
          resolve(reader.result)
        })
        reader.readAsDataURL(file)
      })
    },
    convertFileToDataRaw: function(file) {
      return new Promise(resolve => {
        const reader = new FileReader()
        reader.addEventListener('loadend', () => {
          resolve(reader.result)
        })
        reader.readAsBinaryString(file)
      })
    },
    findPlaceholder: function(id) {
      let decos = view.state['placeholder$']
      let found = decos && decos.find(null, null, spec => spec.id == id)
      return found && found.length ? found[0].from : null
    },
    addPlaceholder(id) {
      const tr = view.state.tr
      if (!tr.selection.empty) {
        tr.deleteSelection()
      }
      tr.setMeta(placeholderPlugin, {
        add: {
          id,
          pos: tr.selection.from,
          src: 'http:///101.picnic.team/file-loading-indicator.svg'
        }
      })
      view.dispatch(tr)
    },
    swapPlaceholder(id, file) {
      let pos = this.findPlaceholder(id)
      if (pos == null) return
      const image = schema.node('image', {
        src: file.__p__value,
        alt: file.filename
      })
      const addImageTransaction = view.state.tr
        .replaceWith(pos, pos, image)
        .setMeta(placeholderPlugin, { remove: { id } })
      view.dispatch(addImageTransaction)
    },
    uploadImage: function(file) {
      // TODO: Upload Image Here

      // The following is just throw away code to convert the file to a url and add a bit of delay
      // return new Promise(resolve => {
      //   this.convertFileToDataUrl(file).then(url => {
      //     setTimeout(() => resolve(url), 2000);
      //   });
      // });

      return this.convertFileToDataRaw(file).then(raw => {
        const filePayload = {
          name: `picnic-upload-${new Date().getTime()}${file.name}`,
          type: file.type,
          size: file.size,
          raw: raw
        }
        return this.uploadSingleFile(filePayload)
      })
    },
    uploadSingleFile(file) {
      const payload = {
        projectId: this.$store.getters.projectId,
        strategyProjectId: this.$store.getters.project.integrationProjectId,
        ticketStrategyId: this.ticketIntegrationId,
        file: file
      }
      return this.$store.dispatch('uploadIntFile', payload)
    },
    parseClipboard(event) {
      const items = [
        ...(event.clipboardData || event.originalEvent.clipboardData).items
      ]
      items.forEach(item => {
        if (item.type.indexOf('image') !== -1) {
          const id = Math.floor(Math.random() * 1000000)
          this.addPlaceholder(id)
          const file = item.getAsFile()
          this.uploadImage(file).then(file => this.swapPlaceholder(id, file))
          // this.convertFileToDataUrl(file).then(url => {
          //   const tr = this.view.state.tr;
          //   if (!tr.selection.empty) {
          //     tr.deleteSelection();
          //   }
          //   tr.setMeta(placeholderPlugin, {
          //     add: { id, pos: tr.selection.from, src: url }
          //   });
          //   this.view.dispatch(tr);
          // });
        }
      })
    }
  },
  mounted() {
    this.initializeProsemirror()
    // Lets handle the paste event ourselves due
    // to limitatations in prosemirror
    if (!pasteEvent) {
      pasteEvent = window.addEventListener('paste', this.parseClipboard)
    }
  },
  destroyed() {
    window.removeEventListener('paste', this.parseClipboard)
    pasteEvent = null
  },
  watch: {
    value(updatedContent) {
      // let updatedDoc = defaultMarkdownParser.parse(updatedContent)
      // view.updateState(createState(updatedDoc))
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.picnic-content-editor .ProseMirror {
  min-height: 1em;
  padding: 0px !important;
  width: 100%;
  &:focus {
    outline: none !important;
  }
}

.ps-editor p {
  margin-bottom: 12px !important;
  line-height: 1.4 !important;
  color: '#4e3d42';
  &:last-of-type {
    margin-bottom: 0 !important;
  }
}
</style>